/*
*###############################################################################
*Module Name                   : CustomerGroupMaster.js                        #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : I Dinisuru Balasuriya                         #
*Date                          : Wednesday, September 1st 2021, 9:44:33 am     #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/


import React, { useState, useEffect } from 'react'
import { CardText, Col, Row, Alert, Button, Label } from 'reactstrap'
import DPTextBox from 'framework/components/DPTextBox'
import DPSwitch from 'framework/components/DPSwitch'
import DPTextBoxButton from 'framework/components/DPTextBoxButton'
import imageExcelUpload from "../../../assets/images/Upload.png"
import imageExcelDownload from "../../../assets/images/Download.png"
import MasterUpload from "../../../assets/File/MasterUpload.xlsx";
import { loadPopupSearchPay } from 'framework/validators/SearchColumn'
import DPSearchBoxDynamic from 'framework/components/DPSearchBoxDynamic'

const CustomerGroupMasterContent = ({
    CodeValue,
    CodeonChange,
    DescValue,
    DescOnChange,
    disabled,
    SwonChange,
    ActiveSw,
    show,
    AlertMsg,
    AlertColor,
    modelOpen,
    modelTrigger,
    GetSelectRow,
    disabledCode,
    CodeOnBlur,
    ErrorMsg,
    menuName,
    onButtonClick,
    btnDisable,
    SearchDisable,
    showFileUpload,
    valueUpload,
    menuCode,
    noPromo,
    otpRequired,
    permRequired,
    minCostVariance,
    minSalesVariance,
    fieldManager,
    autoCode
}) => {

    const [HeadColumns, setHeadColumns] = useState([])
    const [groupFilter, SetGroupFilter] = useState("a")
    const ApiURL = window.Links.ApiURL

    useEffect(() => {
        console.log(fieldManager)
    }, [fieldManager])


    useEffect(async () => {
        setHeadColumns(await loadPopupSearchPay(menuCode, 'CUSTOMGRP'))
    }, [menuCode]);


    async function tog_backdrop() {
        modelTrigger();
    }

    //default sorted method
    const defaultSorted = [{
        dataField: 'id',
        order: 'asc'
    }];

    return (
        <React.Fragment>
            <div>
                <Col sm="12">
                    <CardText className="mb-0">
                        <Row>
                            {show ? (
                                <Alert color={AlertColor} role="alert">
                                    {AlertMsg}
                                    <br />
                                    <small>{ErrorMsg}</small>
                                </Alert>
                            ) : null}
                            <Col sm={12} md={6} className="mb-4-sm">
                                <DPTextBoxButton
                                    rowClass="mb-4-sm"
                                    labelText="Code *"
                                    textType="text"
                                    maxLength="5"
                                    value={CodeValue}
                                    onChange={CodeonChange}
                                    onBlur={CodeOnBlur}
                                    disabled={disabled == true ? disabled : disabledCode}
                                    onButtonClick={onButtonClick}
                                    btnDisable={disabled == true ? disabled : btnDisable}
                                    placeholder={autoCode}
                                />
                                <DPTextBox
                                    rowClass="mb-4-sm"
                                    labelText="Description *"
                                    textType="text"
                                    maxLength="50"
                                    value={DescValue}
                                    onChange={DescOnChange}
                                    disabled={disabled || fieldManager.disable.includes("CG_DESC")}
                                    hidden={fieldManager.disable.includes("CG_DESC") && fieldManager.hidden == true}
                                />
                                <DPTextBox
                                    rowClass="mb-4-sm"
                                    labelText="Minimum Cost Variance *"
                                    textType="text"
                                    maxLength="10"
                                    //placeholder={"Minimum Cost Variance"}
                                    textAlign={'right'}
                                    step={.01}
                                    min={0.00}
                                    value={minCostVariance.getter}
                                    onChange={minCostVariance.change}
                                    onBlur={minCostVariance.onblur}
                                    disabled={disabled || fieldManager.disable.includes("CG_MINCOSTVAR")}
                                    hidden={fieldManager.disable.includes("CG_MINCOSTVAR") && fieldManager.hidden == true}
                                />
                                <DPTextBox
                                    rowClass="mb-4-sm"
                                    labelText="Minimum Sales Variance *"
                                    textType="text"
                                    maxLength="10"
                                    //placeholder={"Minimum Sales Variance"}
                                    textAlign={'right'}
                                    step={.01}
                                    min={0.00}
                                    value={minSalesVariance.getter}
                                    onChange={minSalesVariance.change}
                                    onBlur={minSalesVariance.onblur}
                                    disabled={disabled || fieldManager.disable.includes("CG_MINSALESVAR")}
                                    hidden={fieldManager.disable.includes("CG_MINSALESVAR") && fieldManager.hidden == true}
                                />
                                <Row hidden={fieldManager.disable.includes("CG_STATUS") && fieldManager.hidden == true}>
                                    <Col sm={3}>
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Active
                                        </Label>
                                    </Col>
                                    <Col >
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={SwonChange}
                                            checked={ActiveSw}
                                            disabled={disabled || fieldManager.disable.includes("CG_STATUS")}
                                        />
                                    </Col>
                                </Row>
                                <Row hidden={fieldManager.hidden == true}>
                                    <Col sm={3}>
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            No Promo
                                        </Label>
                                    </Col>
                                    <Col >
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={noPromo.change}
                                            checked={noPromo.getter}
                                            disabled={disabled || fieldManager.disable.includes("CG_NOPROMO")}
                                        />
                                    </Col>
                                </Row>
                                <Row hidden={fieldManager.hidden == true}>
                                    <Col sm={3}>
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            OTP Required
                                        </Label>
                                    </Col>
                                    <Col >
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={otpRequired.change}
                                            checked={otpRequired.getter}
                                            disabled={disabled || fieldManager.disable.includes("CG_OTP_REQUIRED")}
                                        />
                                    </Col>
                                </Row>
                                <Row hidden={fieldManager.hidden == true}>
                                    <Col sm={3}>
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Permission Required
                                        </Label>
                                    </Col>
                                    <Col >
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={permRequired.change}
                                            checked={permRequired.getter}
                                            disabled={disabled || fieldManager.disable.includes("CG_PERMISSION_REQUIRED")}
                                        />
                                    </Col>
                                    <Col sm={6}>
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Note: Once set in the creation, the status of this field is immutable.
                                        </Label>
                                    </Col>
                                </Row>
                            </Col>
                            <Col sm={12} md={4} className="mb-4-sm">
                                <Button
                                    onClick={() => {
                                        tog_backdrop()
                                    }}
                                    color="success"
                                    className="btn-sm"
                                    disabled={SearchDisable}
                                >
                                    <i
                                        className="mdi mdi-search-web"
                                        style={{ fontSize: "12px" }}
                                    ></i>
                                </Button>
                            </Col>
                            <Col sm={12} md={2} className="mb-4-sm">
                                <ul className="import-export-button-block" style={{ display: "flex", flexFlow: "row", flexWrap: "wrap", padding: "0px", justifyContent: "end" }}>
                                    <li className="import-export-button" style={{ display: "block" }}>
                                        <input
                                            id="file"
                                            type="file"
                                            onChange={showFileUpload}
                                            value={valueUpload}
                                            disabled={disabledCode}
                                            accept=".xlsx, .xls, .csv"
                                            style={{ display: "none" }}
                                        />

                                        <label htmlFor="file" title="Master Excel Upload" style={{ cursor: "pointer", opacity: disabledCode == true ? "0.5" : "1" }}>
                                            <span >
                                                <img class="manImg" src={imageExcelUpload} style={{ width: "40px", height: "40px" }}></img>
                                            </span>
                                        </label></li>

                                    <li className="import-export-button" style={{ display: "block" }}>
                                        <a href={MasterUpload} download="Master File Upload" data-tip title="Master excel format download"
                                            style={{ pointerEvents: disabledCode ? 'none' : '', }} >
                                            <img class="manImg" src={imageExcelDownload} style={{ width: "40px", height: "40px", opacity: disabledCode == true ? "0.5" : "1" }}></img>
                                        </a></li>
                                </ul>

                            </Col>

                            <DPSearchBoxDynamic
                                searchData={[]}
                                columns={HeadColumns}
                                defaultSorted={defaultSorted}
                                mainTitle={menuName + " Search"}
                                SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                                isOpen={modelOpen}
                                toggle={modelTrigger}
                                getSelect={GetSelectRow}
                                APIURL={ApiURL}
                                URLPath={"CUSTOMGRP"}
                                MenuCode={menuCode}
                                KeyVal={"GRP"}
                                searchBy={"CG_CODE"}
                                FilterStr={groupFilter}
                            />

                        </Row>
                    </CardText>
                </Col>
            </div>
        </React.Fragment>
    )

}

export default CustomerGroupMasterContent